export const PRODUCT_NAME = 'product_name';
export const PRODUCT_SHORT_DESCRIPTION = 'product_short_description';
export const PRODUCT_SUBHEADER = 'product_subheader';
export const PRODUCT_SUBDISPLAY_NAME = 'product_subdisplay_name';
export const PRODUCT_OVERVIEW_SUMMARY = 'spp_product_overview_summary';
export const SUBSCRIBE_BUTTON = 'product_autoreplenish_subscribe_button';
export const PRODUCT_DESCRIPTION = 'product_description';
export const PRODUCT_DESCRIPTION_READ_MORE = 'product_description_read_more';
export const PRODUCT_PRICE = 'product_price';
export const PRODUCT_PRICE_RANGE = 'product_price_range';
export const PRODUCT_PRICE_PER_UNIT = 'product_price_per_unit';
export const PRODUCT_SIZE = 'product_size';
export const PRODUCT_PROMO_BANNER = 'product-promo-banner';
export const PRODUCT_SIZE_DROPDOWN = 'product_size_dropdown';
export const PRODUCT_BASIC_INFO = 'product_basic_info';
export const PRODUCT_COMPARISON_MODULE = 'product_comparison_module';
export const AFTER_PAY = 'after_pay';
export const SOCIAL_SHARE = 'product_social_share';
export const ACCORDION = 'spp_accordion';
export const SHADES_SIDE_BAR_BUTTON = 'spp_product_shades_sidebar_button';
export const STICKY_PRODUCT_PRICE = 'spp_sticky_product_price';
export const STICKY_PRODUCT_SIZE = 'spp_sticky_product_size';
export const STICKY_PRODUCT_NAME = 'spp_sticky_product_name';
export const PRODUCT_RATING = 'product_rating';
export const PRODUCT_LEARN_MORE_LINK = 'product_learn_more_link';
export const MPP_ADD_TO_BAG = 'mpp_add_to_bag';
export const MPP_SHADE_SELECT = 'mpp_shade_select';
export const MPP_SHADE_NAME = 'mpp_shade_name';
export const MPP_PRODUCT_DETAILS = 'mpp_product_details';
export const MPP_SORT_BY = 'mpp_sort_by';
export const MPP_PRODUCT_SORTING_DROPDOWN = 'elc-product-sorting-dropdown';
export const CART_PRODUCT_QUANTITY = 'cart_product_quantity';
export const D_T_ID = 'd-t-id';
export const AUTO_REPLENISH_VIEW = 'autoReplenishView';
export const VTO_MAKEUP_BUTTON = 'vto-button-makeup';
export const VTO_FOUNDATION_BUTTON = 'vto-button-foundation';
export const VTO_PERFECT_SHADES_BUTTON = 'vto-button-perfect-shades';
export const VTO_ALL_SHADES_BUTTON = 'vto-button-all-shades';
export const VTO_SHADE_SELECT = 'vto_shade_select';
export const SHIPS_BY_MESSAGE = 'ships_by_message';
export const PREORDER_NOT_AVAILABLE_MESSAGE = 'preorder_not_available_message';
export const PREORDER_BUTTON = 'preorder_button';
export const PREORDER_BUTTON_DISABLED = 'preorder_button_disabled';
export const ADD_TO_BAG_BUTTON = 'add_to_bag_btn';
export const ADD_TO_BAG_BUTTON_DISABLED = 'add_to_bag_btn_disabled';
export const PRODUCT_IMAGE_BADGE = 'product-image-badge';
export const FREE_SHIPPING_AND_RETURN_FEATURE = 'free_shipping_and_return_feature';
export const PERFECT_FOR_FEATURE = 'perfect_for_feature';
export const ADD_TO_COLLECTION_BUTTON = 'add_to_collection_btn';
export const TAX_INCLUDED = 'tax-included';
export const BEST_SHADE_MESSAGE = 'best-shade-message';
export const DISCOUNT_PERCENT = 'discount-percent';
export const ONSALE_TODAY_LABEL = 'onsale-today-label';
export const DISCOUNT_LOYALTY_MESSAGE = 'discount-loyalty-message';
